var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.57608,
    y: 4.54544,
    width: 3.63648,
    height: 5.81831,
    rx: 0.927794,
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30313 14.5195C4.30313 13.9306 4.62848 13.4411 5.10614 13.2465C6.32864 12.7485 8.04026 12.1817 9.39418 12.1817C10.7481 12.1817 12.4597 12.7485 13.6822 13.2465C14.1599 13.4411 14.4852 13.9306 14.4852 14.5195V19.0909H4.30313V14.5195Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4848,
    y: 20.9091,
    width: 3.63648,
    height: 5.81831,
    rx: 0.927794,
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2123 30.8832C25.2123 30.2942 25.5377 29.8048 26.0153 29.6102C27.2378 29.1121 28.9494 28.5453 30.3034 28.5453C31.6573 28.5453 33.3689 29.1121 34.5914 29.6102C35.0691 29.8048 35.3944 30.2942 35.3944 30.8832V35.4546H25.2123V30.8832Z",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9999 16.3636V9.99997C29.9999 8.99582 29.1859 8.18179 28.1817 8.18179H19.0908",
    stroke: "currentColor",
    strokeWidth: 1.81818,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7534 5.45454L18.1821 8.02584L20.7534 10.5971",
    stroke: "currentColor",
    strokeWidth: 1.81818,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.09091 23.6026L9.09091 29.9663C9.09091 30.9704 9.90494 31.7845 10.9091 31.7845L20 31.7845",
    stroke: "currentColor",
    strokeWidth: 1.81818,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3374 34.5117L20.9087 31.9404L18.3374 29.3691",
    stroke: "currentColor",
    strokeWidth: 1.81818,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeManagement);
export default __webpack_public_path__ + "static/media/Employee Management.f247f295fcf19fde35daf0efd8052b64.svg";
export { ForwardRef as ReactComponent };